import React, { useState } from 'react';

import { Box, List } from '@mui/material';

import type { Column } from 'api/shared/models';

import { styles } from '../styles';

import OptionDragAndDrop from './OptionDragAndDrop';
import Option from './Option';

interface Props {
  columns: Column[];
  showConfigName: boolean;
  addDragAndDrop?: boolean;
  onClick: (column: Column) => void;
  moveRows?: (rowIndex: number, newIndex: number) => void;
}

const ColumnOptions = ({
  columns,
  onClick,
  showConfigName,
  addDragAndDrop,
  moveRows,
}: Props) => {
  const [indexTarget, setIndexTarget] = useState<number | null>(null);

  return (
    <Box sx={styles.rootOptions(showConfigName)}>
      <List>
        {columns.map((column, index) => (
          <React.Fragment key={index}>
            {addDragAndDrop && moveRows ? (
              <OptionDragAndDrop
                index={index}
                column={column}
                onClick={onClick}
                indexTarget={indexTarget}
                setIndexTarget={setIndexTarget}
                moveRows={moveRows}
              />
            ) : (
              <Option column={column} onClick={onClick} />
            )}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
};

export default ColumnOptions;
